import React, {
    useEffect,
    useState
  } from "react";
  
  import "../styles/AdminRejectModal.css";
  
  
  const AdminRejectModal = ({
    isOpen,
    userName,
    loading,
    onClose,
    onConfirm
  }) => {
  
    const [reason, setReason] =
      useState("");
  
  
    useEffect(() => {
      if (isOpen) {
        setReason("");
      }
    }, [isOpen]);
  
  
    useEffect(() => {
  
      if (!isOpen) {
        return;
      }
  
      const handleEscape = (event) => {
        if (
          event.key === "Escape" &&
          !loading
        ) {
          onClose();
        }
      };
  
      window.addEventListener(
        "keydown",
        handleEscape
      );
  
      return () => {
        window.removeEventListener(
          "keydown",
          handleEscape
        );
      };
  
    }, [
      isOpen,
      loading,
      onClose
    ]);
  
  
    if (!isOpen) {
      return null;
    }
  
  
    const handleSubmit = (event) => {
      event.preventDefault();
  
      if (loading) {
        return;
      }
  
      onConfirm(
        reason.trim()
      );
    };
  
  
    return (
      <div
        className="admin-reject-overlay"
        onMouseDown={(event) => {
          if (
            event.target === event.currentTarget &&
            !loading
          ) {
            onClose();
          }
        }}
      >
  
        <div
          className="admin-reject-modal"
          role="dialog"
          aria-modal="true"
          aria-labelledby="admin-reject-title"
        >
  
          <h2 id="admin-reject-title">
            Rejeter le dossier
          </h2>
  
          <p>
            Vous êtes sur le point de rejeter
            le dossier de{" "}
            <strong>
              {userName || "cet utilisateur"}
            </strong>.
          </p>
  
  
          <form onSubmit={handleSubmit}>
  
            <label
              htmlFor="admin-rejection-reason"
            >
              Motif du rejet
            </label>
  
            <textarea
              id="admin-rejection-reason"
              value={reason}
              onChange={(event) =>
                setReason(event.target.value)
              }
              placeholder="Ex. Document justificatif illisible..."
              rows={5}
              disabled={loading}
            />
  
  
            <div className="admin-reject-modal-actions">
  
              <button
                type="button"
                className="admin-reject-cancel"
                onClick={onClose}
                disabled={loading}
              >
                Annuler
              </button>
  
              <button
                type="submit"
                className="admin-reject-confirm"
                disabled={loading}
              >
                {loading
                  ? "Rejet en cours..."
                  : "Confirmer le rejet"}
              </button>
  
            </div>
  
          </form>
  
        </div>
  
      </div>
    );
  };
  
  export default AdminRejectModal;